import { defaultClient } from '@mint-sdk/api-core';
import z from 'zod';

import {
  NamingConventionCreateRequestSchema,
  NamingConventionEntityOptionsResponseSchema,
  NamingConventionQuerySchema,
  NamingConventionResponseSchema,
  NamingConventionSeparatorsResponseSchema,
  NamingConventionUpdateRequestSchema,
  type EntitySchema,
  type NamingConventionSchema,
} from './schemas.js';

export const getNamingConventionList = defaultClient.query({
  url: 'naming-convention-v2/v1/naming-conventions/' as const,
  method: 'GET',
  querySchema: NamingConventionQuerySchema,
  responseSchema: NamingConventionResponseSchema,
  snakeCaseQueryParams: true,
  processResponse(data) {
    return data?.data?.items;
  },
});

export const getSeparators = defaultClient.query({
  url: 'naming-convention-v2/v1/naming-conventions/separators/' as const,
  method: 'GET',
  responseSchema: NamingConventionSeparatorsResponseSchema,
  processResponse(data) {
    return data?.data?.items;
  },
});

export const getEntityOptions = defaultClient.query({
  url: 'naming-convention-v2/v1/naming-conventions/entity-options/' as const,
  method: 'GET',
  querySchema: NamingConventionQuerySchema,
  responseSchema: NamingConventionEntityOptionsResponseSchema,
  processResponse(data) {
    return data?.data?.items;
  },
});

export const createNamingConvention = defaultClient.mutation({
  url: 'naming-convention-v2/v1/naming-conventions/' as const,
  method: 'POST',
  requestSchema: NamingConventionCreateRequestSchema,
  responseSchema: NamingConventionResponseSchema,
  processResponse(data) {
    return data?.data?.items[0];
  },
});

export const updateNamingConvention = defaultClient.mutation({
  url: 'naming-convention-v2/v1/naming-conventions/$id/' as const,
  method: 'PATCH',
  requestSchema: NamingConventionUpdateRequestSchema,
  responseSchema: NamingConventionResponseSchema,
  processResponse(data) {
    return data?.data?.items[0];
  },
});

export const deleteNamingConvention = defaultClient.mutation({
  url: 'naming-convention-v2/v1/naming-conventions/$id/' as const,
  method: 'DELETE',
  responseSchema: z.object({}),
});

export type UseAsEnum = z.infer<typeof EntitySchema.shape.useAs>;
export type EntityType = z.infer<typeof EntitySchema>;
export type EntityOptionType = z.infer<typeof EntitySchema.shape.entityOption>;
export type NamingConventionType = z.infer<typeof NamingConventionSchema>;
export type NamingConventionCreateRequestType = z.infer<
  typeof NamingConventionCreateRequestSchema
>;
